<template>
  <Configuration :items="items" :width="1089" :height="442">
    <template v-slot:base>
      <svg
        class="base"
        fill="none"
        width="1440"
        height="900"
        viewBox="0 0 1440 900"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1440 0H0V900H1440V0Z" fill="#F7FAFC" />
        <path d="M212 810.64V60.64" stroke="#E6E7E8" stroke-miterlimit="10" />
        <path d="M381.33 810.64V60.64" stroke="#E6E7E8" stroke-miterlimit="10" />
        <path d="M550.67 810.64V60.64" stroke="#E6E7E8" stroke-miterlimit="10" />
        <path d="M720 810.64V60.64" stroke="#E6E7E8" stroke-miterlimit="10" />
        <path d="M889.33 810.64V60.64" stroke="#E6E7E8" stroke-miterlimit="10" />
        <path d="M1058.67 810.64V60.64" stroke="#E6E7E8" stroke-miterlimit="10" />
        <path d="M1228 810.64V60.64" stroke="#E6E7E8" stroke-miterlimit="10" />
        <path d="M212 60.64H1228" stroke="#E6E7E8" stroke-miterlimit="10" />
        <path d="M212 110.64H1228" stroke="#E6E7E8" stroke-miterlimit="10" />
        <path d="M212 160.64H1228" stroke="#E6E7E8" stroke-miterlimit="10" />
        <path d="M212 210.64H1228" stroke="#E6E7E8" stroke-miterlimit="10" />
        <path d="M212 260.64H1228" stroke="#E6E7E8" stroke-miterlimit="10" />
        <path d="M212 310.64H1228" stroke="#E6E7E8" stroke-miterlimit="10" />
        <path d="M212 360.64H1228" stroke="#E6E7E8" stroke-miterlimit="10" />
        <path d="M212 410.64H1228" stroke="#E6E7E8" stroke-miterlimit="10" />
        <path d="M212 460.64H1228" stroke="#E6E7E8" stroke-miterlimit="10" />
        <path d="M212 510.64H1228" stroke="#E6E7E8" stroke-miterlimit="10" />
        <path d="M212 560.64H1228" stroke="#E6E7E8" stroke-miterlimit="10" />
        <path d="M212 610.64H1228" stroke="#E6E7E8" stroke-miterlimit="10" />
        <path d="M212 660.64H1228" stroke="#E6E7E8" stroke-miterlimit="10" />
        <path d="M212 710.64H1228" stroke="#E6E7E8" stroke-miterlimit="10" />
        <path d="M212 760.64H1228" stroke="#E6E7E8" stroke-miterlimit="10" />
        <path d="M212 810.64H1228" stroke="#E6E7E8" stroke-miterlimit="10" />
        <path
          d="M212 811.37H1228"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M889.37 834.18C897.654 834.18 904.37 832.483 904.37 830.39C904.37 828.297 897.654 826.6 889.37 826.6C881.086 826.6 874.37 828.297 874.37 830.39C874.37 832.483 881.086 834.18 889.37 834.18Z"
          stroke="#BCBEC0"
          stroke-miterlimit="10"
        />
        <g filter="url(#filter0_d_864_2)">
          <path
            d="M965.08 493.83H815.65C813.7 493.83 812.12 492.25 812.12 490.3V165.89C812.12 163.94 813.7 162.36 815.65 162.36H965.08C967.03 162.36 968.61 163.94 968.61 165.89V490.3C968.61 492.25 967.03 493.83 965.08 493.83"
            fill="#F7FAFC"
          />
          <path
            d="M965.08 493.83H815.65C813.7 493.83 812.12 492.25 812.12 490.3V165.89C812.12 163.94 813.7 162.36 815.65 162.36H965.08C967.03 162.36 968.61 163.94 968.61 165.89V490.3C968.61 492.25 967.03 493.83 965.08 493.83"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M890.37 214.86C889.04 214.86 887.96 214.18 887.96 213.35C887.96 212.52 889.04 211.85 890.37 211.85C891.7 211.85 892.78 212.53 892.78 213.35C892.78 214.17 891.7 214.86 890.37 214.86ZM890.37 216.99C886.79 216.99 884.29 215.07 884.29 213.35C884.29 211.63 886.79 209.72 890.37 209.72C893.95 209.72 896.45 211.64 896.45 213.35C896.45 215.06 893.95 216.99 890.37 216.99ZM890.37 217.09C886.37 217.09 883.13 215.06 883.13 212.57C883.13 210.08 886.38 208.05 890.37 208.05C894.36 208.05 897.61 210.08 897.61 212.57C897.61 215.06 894.36 217.09 890.37 217.09ZM890.37 217.09C884.54 217.09 879.8 212.35 879.8 206.52C879.8 200.69 884.54 195.95 890.37 195.95C896.2 195.95 900.94 200.69 900.94 206.52C900.94 212.35 896.2 217.09 890.37 217.09ZM907.49 206.52C907.49 215.97 899.83 223.64 890.37 223.64C880.91 223.64 873.25 215.98 873.25 206.52C873.25 197.06 880.91 189.4 890.37 189.4C899.83 189.4 907.49 197.06 907.49 206.52Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M890.37 214.86C889.04 214.86 887.96 214.18 887.96 213.35C887.96 212.52 889.04 211.85 890.37 211.85C891.7 211.85 892.78 212.53 892.78 213.35C892.78 214.17 891.7 214.86 890.37 214.86ZM890.37 217.09C886.37 217.09 883.13 215.06 883.13 212.57C883.13 210.08 886.38 208.05 890.37 208.05C894.36 208.05 897.61 210.08 897.61 212.57C897.61 215.06 894.36 217.09 890.37 217.09ZM890.37 217.09C884.54 217.09 879.8 212.35 879.8 206.52C879.8 200.69 884.54 195.95 890.37 195.95C896.2 195.95 900.94 200.69 900.94 206.52C900.94 212.35 896.2 217.09 890.37 217.09ZM907.49 206.52C907.49 215.97 899.83 223.64 890.37 223.64C880.91 223.64 873.25 215.98 873.25 206.52C873.25 197.06 880.91 189.4 890.37 189.4C899.83 189.4 907.49 197.06 907.49 206.52Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M848.06 408.332H933.89C935.38 408.332 936.59 409.542 936.59 411.032V477.992C936.59 479.482 935.38 480.692 933.89 480.692H848.06C846.57 480.692 845.36 479.482 845.36 477.992V411.032C845.36 409.542 846.57 408.332 848.06 408.332Z"
          stroke="black"
          stroke-width="1.5"
        />
        <path
          d="M920.66 468.082H860.93C858.94 468.082 857.32 466.462 857.32 464.472V424.612C857.32 422.622 858.94 421.002 860.93 421.002H920.66C922.65 421.002 924.27 422.622 924.27 424.612V464.472C924.27 466.462 922.65 468.082 920.66 468.082Z"
          stroke="black"
          stroke-width="1.5"
        />
        <path
          d="M918.61 461.682L923.55 466.812M862.89 461.682L857.99 466.812M918.61 461.682V421.012M862.88 421.012V461.682M918.6 461.682H863"
          stroke="black"
          stroke-width="1.5"
        />
        <path
          d="M848.06 408.332H933.89C935.38 408.332 936.59 409.542 936.59 411.032V477.992C936.59 479.482 935.38 480.692 933.89 480.692H848.06C846.57 480.692 845.36 479.482 845.36 477.992V411.032C845.36 409.542 846.57 408.332 848.06 408.332Z"
          stroke="#231F20"
          stroke-width="1.5"
        />
        <path
          d="M920.66 468.082H860.93C858.94 468.082 857.32 466.462 857.32 464.472V424.612C857.32 422.622 858.94 421.002 860.93 421.002H920.66C922.65 421.002 924.27 422.622 924.27 424.612V464.472C924.27 466.462 922.65 468.082 920.66 468.082Z"
          stroke="#231F20"
          stroke-width="1.5"
        />
        <path
          d="M918.61 461.682L923.55 466.812M862.89 461.682L857.99 466.812M918.61 461.682V421.012M862.88 421.012V461.682M918.6 461.682H863"
          stroke="#231F20"
          stroke-width="1.5"
        />
        <g filter="url(#filter1_d_864_2)">
          <path
            d="M471.51 516.15V484.68C471.51 482.48 473.29 480.7 475.48 480.7H627.65C629.84 480.7 631.61 482.48 631.61 484.68V516.16L635.14 530.34V809.96C635.14 811.66 634.05 813.17 632.44 813.69L584.52 829.35H518.6L469.53 813.67C467.91 813.15 466.8 811.64 466.8 809.93V530.33L471.51 516.15Z"
            fill="#F7FAFC"
          />
          <path
            d="M471.51 516.15V484.68C471.51 482.48 473.29 480.7 475.48 480.7H627.65C629.84 480.7 631.61 482.48 631.61 484.68V516.16L635.14 530.34V809.96C635.14 811.66 634.05 813.17 632.44 813.69L584.52 829.35H518.6L469.53 813.67C467.91 813.15 466.8 811.64 466.8 809.93V530.33L471.51 516.15Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <path
          d="M661.048 573.57C661.048 577.99 657.478 581.58 653.068 581.58C648.658 581.58 645.088 577.99 645.088 573.57C645.088 569.15 648.658 565.56 653.068 565.56C657.478 565.56 661.048 569.15 661.048 573.57Z"
          stroke="black"
          stroke-width="1.5"
        />
        <path
          d="M540.2 785.204V808.293C540.2 816.263 546.25 822.723 553.71 822.723C561.17 822.723 567.22 816.263 567.22 808.293V785.204"
          stroke="black"
          stroke-width="1.5"
        />
        <path
          d="M551.2 509.523C555.939 509.523 559.78 505.964 559.78 501.574C559.78 497.183 555.939 493.624 551.2 493.624C546.461 493.624 542.62 497.183 542.62 501.574C542.62 505.964 546.461 509.523 551.2 509.523Z"
          stroke="black"
          stroke-width="1.5"
        />
        <path
          d="M553.16 498.914H549.24C547.042 498.914 545.26 500.695 545.26 502.893V509.493C545.26 511.692 547.042 513.473 549.24 513.473H553.16C555.358 513.473 557.14 511.692 557.14 509.493V502.893C557.14 500.695 555.358 498.914 553.16 498.914Z"
          fill="#F7FAFC"
          stroke="black"
          stroke-width="1.5"
        />
        <path
          d="M467.8 533.543L520.77 551.274H584.34L636.14 533.543"
          stroke="black"
          stroke-width="1.5"
        />
        <path d="M520.12 780.074V830.783" stroke="black" stroke-width="1.5" />
        <path d="M520.77 551.274V699.024" stroke="black" stroke-width="1.5" />
        <path d="M585 780.084V830.783" stroke="black" stroke-width="1.5" />
        <path d="M584.34 551.274V699.024" stroke="black" stroke-width="1.5" />
        <path d="M472.51 518.764H632.61" stroke="black" stroke-width="1.5" />
        <path
          d="M611.03 535.533C617.92 533.693 619.66 531.853 619.66 531.853C619.66 531.853 619.66 526.674 599.65 523.564H503.71C483.7 526.674 484.29 531.853 484.29 531.853C484.29 531.853 490.18 538.073 523.14 539.103C556.1 540.143 580.82 539.103 580.82 539.103C585.32 538.963 589.32 538.723 592.86 538.413L611.04 535.524L611.03 535.533Z"
          stroke="black"
          stroke-width="1.5"
        />
        <path
          d="M510.55 606.464C514.51 618.554 511.2 630.514 503.16 633.164C495.12 635.824 485.39 628.174 481.43 616.074C477.47 603.984 480.78 592.024 488.82 589.374C496.86 586.714 506.59 594.364 510.55 606.464Z"
          stroke="black"
          stroke-width="1.5"
        />
        <path
          d="M620.84 714.964C620.84 714.964 632.42 732.693 592.4 748.053C592.4 748.053 573.75 756.324 558.45 757.504H547.86C532.56 756.324 512.54 748.053 512.54 748.053C472.51 732.693 482.98 716.423 482.98 716.423"
          stroke="black"
          stroke-width="1.5"
        />
        <path
          d="M491.34 758.694C491.34 758.694 478.3 743.314 481.92 719.694C483.68 708.244 503.1 702.693 522.14 698.743L582.96 698.793C601.81 702.813 620.86 708.354 622.59 719.694C626.21 743.314 613.17 758.694 613.17 758.694C597.57 780.454 568.4 786.713 554.44 786.223C539.12 786.223 508.22 782.224 491.34 758.694V758.694Z"
          stroke="black"
          stroke-width="1.5"
        />
        <path
          d="M552.18 750.814C537.04 750.814 507.74 739.614 505.8 726.204C504.5 717.264 511.54 711.764 526.91 709.714H578.57C594.13 711.454 601.49 716.853 600.64 725.923C599.36 739.523 566.71 750.814 552.18 750.814Z"
          stroke="black"
          stroke-width="1.5"
        />
        <path
          d="M617.27 561.134C617.27 565.554 613.7 569.144 609.29 569.144C604.88 569.144 601.31 565.554 601.31 561.134C601.31 556.714 604.88 553.124 609.29 553.124C613.7 553.124 617.27 556.714 617.27 561.134Z"
          stroke="black"
          stroke-width="1.5"
        />
        <path
          d="M612.49 561.134C612.49 562.904 611.06 564.343 609.29 564.343C607.52 564.343 606.09 562.904 606.09 561.134C606.09 559.364 607.52 557.923 609.29 557.923C611.06 557.923 612.49 559.364 612.49 561.134Z"
          stroke="black"
          stroke-width="1.5"
        />
        <path
          d="M602.31 539.73C594.38 540.87 592.18 538.79 592.18 538.79C590.73 534.36 594.35 529.96 598.98 528.84C603.81 527.67 608.7 530.5 610.15 534.92C610.15 534.92 608.5 538.84 602.31 539.73"
          fill="#F7FAFC"
        />
        <path
          d="M602.31 539.73C594.38 540.87 592.18 538.79 592.18 538.79C590.73 534.36 594.35 529.96 598.98 528.84C603.81 527.67 608.7 530.5 610.15 534.92C610.15 534.92 608.5 538.84 602.31 539.73"
          stroke="black"
          stroke-width="1.5"
        />
        <path
          d="M736.52 24.87H703.49V851.93H736.52V24.87Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1073.4 24.87H1040.37V851.93H1073.4V24.87Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M397.33 410.63H364.3V851.93H397.33V410.63Z"
          fill="#F7FAFC"
          stroke="#BCBEC0"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M1174.68 832.1H1229.04V34.32H1174.68V832.1Z"
          fill="url(#paint0_linear_864_2)"
        />
        <path d="M265.32 34.32H210.96V832.1H265.32V34.32Z" fill="url(#paint1_linear_864_2)" />
        <path
          d="M619.28 650.33C619.28 656.52 614.26 661.53 608.07 661.53C601.88 661.53 596.86 656.52 596.86 650.33C596.86 644.14 601.88 639.13 608.07 639.13C614.26 639.13 619.28 644.14 619.28 650.33Z"
          stroke="#231F20"
          stroke-width="1.5"
        />
        <path
          d="M611.86 650.33C611.86 652.42 610.16 654.12 608.06 654.12C605.96 654.12 604.26 652.42 604.26 650.33C604.26 648.24 605.96 646.54 608.06 646.54C610.16 646.54 611.86 648.24 611.86 650.33Z"
          stroke="#231F20"
          stroke-width="1.5"
        />
        <path
          d="M900.36 381.58C900.36 387.77 895.34 392.78 889.15 392.78C882.96 392.78 877.94 387.77 877.94 381.58C877.94 375.39 882.96 370.38 889.15 370.38C895.34 370.38 900.36 375.39 900.36 381.58Z"
          stroke="#231F20"
          stroke-width="1.5"
        />
        <path
          d="M892.95 381.58C892.95 383.67 891.25 385.37 889.15 385.37C887.05 385.37 885.35 383.67 885.35 381.58C885.35 379.49 887.05 377.79 889.15 377.79C891.25 377.79 892.95 379.49 892.95 381.58Z"
          stroke="#231F20"
          stroke-width="1.5"
        />
        <path
          d="M526.22 501.98C526.22 506.64 522.66 510.42 518.26 510.42C513.86 510.42 510.3 506.64 510.3 501.98C510.3 497.32 513.86 493.54 518.26 493.54C522.66 493.54 526.22 497.32 526.22 501.98Z"
          stroke="#231F20"
          stroke-width="1.5"
        />
        <path
          d="M592.58 501.98C592.58 506.64 589.02 510.42 584.62 510.42C580.22 510.42 576.66 506.64 576.66 501.98C576.66 497.32 580.22 493.54 584.62 493.54C589.02 493.54 592.58 497.32 592.58 501.98Z"
          stroke="#231F20"
          stroke-width="1.5"
        />
        <defs>
          <filter
            id="filter0_d_864_2"
            x="809.12"
            y="161.36"
            width="160.49"
            height="335.47"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_864_2"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_864_2"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_864_2"
            x="463.8"
            y="479.7"
            width="172.34"
            height="352.65"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
          >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="-2" dy="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 0 0.733333 0 0 0 1 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_864_2"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_864_2"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_864_2"
            x1="1229.03"
            y1="433.21"
            x2="1174.67"
            y2="433.21"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.15" stop-color="#F7FAFC" />
            <stop offset="1" stop-color="#F7FAFC" stop-opacity="0" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_864_2"
            x1="210.96"
            y1="433.21"
            x2="265.33"
            y2="433.21"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.15" stop-color="#F7FAFC" />
            <stop offset="1" stop-color="#F7FAFC" stop-opacity="0" />
          </linearGradient>
        </defs>
      </svg>
    </template>
  </Configuration>
</template>

<script>
export default {
  name: 'ConfigurationFront',
  data: () => ({
    items: [
      {
        label: 'Button',
        value: 'button',
        x: 405,
        y: 192,
        title: 'PWT Button',
        content: 'Waterproof, rugged assemblies for high abuse installations.',
        link: '/commercial-bathroom-products/water-technology/push-buttons',
        linkText: 'View PWT Buttons'
      },
      {
        label: 'Shower Systems',
        value: 'showerhead',
        x: 651,
        y: 126,
        title: 'Shower Systems',
        content:
          'Control temperature variables, water run times, and sensor range for every shower station.',
        link: '/commercial-bathroom-products/water-technology/shower-systems',
        linkText: 'View PWT Shower Systems'
      }
    ]
  })
};
</script>
